export default __webpack_public_path__ + "static/media/logo.0e623e14.png";